var map = {
	"./dev": [
		679,
		41
	],
	"./dev.ts": [
		679,
		41
	],
	"./local": [
		680,
		42
	],
	"./local.ts": [
		680,
		42
	],
	"./perf": [
		681,
		43
	],
	"./perf.ts": [
		681,
		43
	],
	"./prod": [
		682,
		44
	],
	"./prod.ts": [
		682,
		44
	],
	"./prodfunk": [
		683,
		45
	],
	"./prodfunk.ts": [
		683,
		45
	],
	"./prodzurich": [
		684,
		46
	],
	"./prodzurich.ts": [
		684,
		46
	],
	"./stage": [
		685,
		47
	],
	"./stage.ts": [
		685,
		47
	],
	"./stagezurich": [
		686,
		48
	],
	"./stagezurich.ts": [
		686,
		48
	],
	"./test": [
		687,
		49
	],
	"./test.ts": [
		687,
		49
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 978;
module.exports = webpackAsyncContext;